import { createContext } from "react";

const logs: any[] = [
    {
        "userName": "Mukesh salaria",
        "userEmail": "salaria01@gmail.com",
        "url": `${window.location.origin}/rateFee`,
        "deviceType": "Desktop",
        "browser": "Google Chrome",
        "toDate": "March 10th 2025, 6:31:23 pm",
        "city": "Mohali",
        "country": "India",
        "description": "Mukesh salaria has updated the Discount from 0.00 to 0.20 where scenario is <b>65 Owner occupied P&I Variable</b>.",
        "operatingSystem": "Windows"
    },
    {
        "userName": "Mukesh salaria",
        "userEmail": "salaria01@gmail.com",
        "url": `${window.location.origin}/macquarieRates`,
        "deviceType": "Desktop",
        "browser": "Google Chrome",
        "toDate": "March 10th 2025, 6:31:12 pm",
        "city": "Mohali",
        "country": "India",
        "description": "Mukesh salaria has updated the Basic interest rate from 6.19 to 6.35 where scenario is <b>80 Owner occupied P&I Variable</b>",
        "operatingSystem": "Windows"
    },
    {
        "userName": "Mukesh salaria",
        "userEmail": "salaria01@gmail.com",
        "url": `${window.location.origin}/macquarieRates`,
        "deviceType": "Desktop",
        "browser": "Google Chrome",
        "toDate": "March 10th 2025, 6:31:10 pm",
        "city": "Mohali",
        "country": "India",
        "description": "Mukesh salaria has updated the Basic interest rate from 6.14 to 6.28 where scenario is <b>60 Owner occupied P&I Variable</b>",
        "operatingSystem": "Windows"
    },
    {
        "userName": "Mukesh salaria",
        "userEmail": "salaria01@gmail.com",
        "url": `${window.location.origin}/rateFee`,
        "deviceType": "Desktop",
        "browser": "Google Chrome",
        "toDate": "March 10th 2025, 6:31:05 pm",
        "city": "Mohali",
        "country": "India",
        "description": "Mukesh salaria has updated the Discount from 0.00 to 0.10 where scenario is <b>60 Owner occupied P&I Variable</b>.",
        "operatingSystem": "Windows"
    },
    {
        "userName": "Mukesh salaria",
        "userEmail": "salaria01@gmail.com",
        "url": `${window.location.origin}/rateFee`,
        "deviceType": "Desktop",
        "browser": "Google Chrome",
        "toDate": "March 10th 2025, 6:30:57 pm",
        "city": "Mohali",
        "country": "India",
        "description": "Mukesh salaria has updated the Discount from 0.00 to 0.10 where scenario is <b>75 Owner occupied P&I Variable</b>.",
        "operatingSystem": "Windows"
    },
    {
        "userName": "Mukesh salaria",
        "userEmail": "salaria01@gmail.com",
        "url": `${window.location.origin}/rateFee`,
        "deviceType": "Desktop",
        "browser": "Google Chrome",
        "toDate": "March 10th 2025, 6:30:50 pm",
        "city": "Mohali",
        "country": "India",
        "description": "Mukesh salaria has updated the Discount from 0.20 to 0.00 where scenario is <b>75 Owner occupied P&I Variable</b>.",
        "operatingSystem": "Windows"
    },
    {
        "userName": "Mukesh salaria",
        "userEmail": "salaria01@gmail.com",
        "url": `${window.location.origin}/rateFee`,
        "deviceType": "Desktop",
        "browser": "Google Chrome",
        "toDate": "March 10th 2025, 6:30:40 pm",
        "city": "Mohali",
        "country": "India",
        "description": "Mukesh salaria has updated the Discount from 0.00 to 0.20 where scenario is <b>75 Owner occupied P&I Variable</b>.",
        "operatingSystem": "Windows"
    },
    {
        "userName": "Mukesh salaria",
        "userEmail": "salaria01@gmail.com",
        "url": `${window.location.origin}/rateFee`,
        "deviceType": "Desktop",
        "browser": "Google Chrome",
        "toDate": "March 10th 2025, 6:30:34 pm",
        "city": "Mohali",
        "country": "India",
        "description": "Mukesh salaria has updated the Discount from 0.00 to 0.10 where scenario is <b>50 Owner occupied P&I Variable</b>.",
        "operatingSystem": "Windows"
    }
  ];

  export const ActivityLogsContext = createContext<any[]>(logs)